
export const mapContextualAnalysisData = (responseData: any): Stories.ContextualFeedback => {
  const normalized: Stories.ContextualFeedback = {
    ...responseData,
    strengths: Array.isArray(responseData?.strengths) ? responseData.strengths : [],
    adjustments: Array.isArray(responseData?.adjustments) ? responseData.adjustments : [],
    breakdown: Array.isArray(responseData?.breakdown) ? responseData.breakdown : [],
  };

  return normalized;
};